import {Injectable} from '@angular/core';
import {LocalStorageService} from './local-storage.service';
import {ApplicationConfig} from '../../../config/application.config';

@Injectable()
export class UserPreferencesService {
  constructor(private localStorageService: LocalStorageService, private applicationConfig: ApplicationConfig) {}
  public getCompanyLogoUrl(): string {
    const url = this.localStorageService.getCompanyLogoUrl();
    return (url != null) ? url : this.applicationConfig.DEFAULT_LOGO_URL;
  }

  public getBackgroundUrl(): string {
    const url = this.localStorageService.getBackgroundUrl();
    return (url != null) ? url : this.applicationConfig.DEFAULT_BACKGROUND_URL;
  }

  public getPrimaryColor(): string {
    const color = this.localStorageService.getPrimaryColor();
    return (color != null) ? color : this.applicationConfig.DEFAULT_PRIMARY_COLOR;
  }

  public getPrimaryTextColor(): string {
    const color = this.localStorageService.getPrimaryTextColor();
    return (color != null) ? color : this.applicationConfig.DEFAULT_PRIMARY_TEXT_COLOR;
  }

  public getSecondaryColor(): string {
    const color = this.localStorageService.getSecondaryColor();
    return (color != null) ? color : this.applicationConfig.DEFAULT_SECONDARY_COLOR;
  }

  public getSecondaryTextColor(): string {
    const color = this.localStorageService.getSecondaryTextColor();
    return (color != null) ? color : this.applicationConfig.DEFAULT_SECONDARY_TEXT_COLOR;
  }

  public getFont(): string {
    const font = this.localStorageService.getFont();
    return (font != null) ? font : this.applicationConfig.DEFAULT_FONT;
  }

  public getTextColor(): string {
    const color = this.localStorageService.getTextColor();
    return (color != null) ? color : this.applicationConfig.DEFAULT_TEXT_COLOR;
  }

  public getTitleTextColor(): string {
    const color = this.localStorageService.getTitleTextColor();
    return (color != null) ? color : this.applicationConfig.DEFAULT_TITLE_TEXT_COLOR;
  }

  public setPrimaryColor(color: string) {
    this.localStorageService.setPrimaryColor(color);
  }

  public setSecondaryColor(color: string) {
    this.localStorageService.setSecondaryColor(color);
  }
}
